'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Author: Alexandre Havrileck (Oxyno-zeta)
 * Date: 27/02/18
 * Licence: See Readme
 */

/* ************************************* */
/* ********       IMPORTS       ******** */
/* ************************************* */

/* ************************************* */
/* ********      VARIABLES      ******** */
/* ************************************* */
var VALUE = 'value';
var KEY = 'key';

/* ************************************* */
/* ********       CLASSES       ******** */
/* ************************************* */

/* ************************************* */
/* ********  PRIVATE FUNCTIONS  ******** */
/* ************************************* */

/* ************************************* */
/* ********   PUBLIC FUNCTIONS  ******** */
/* ************************************* */

/* ************************************* */
/* ********       EXPORTS       ******** */
/* ************************************* */
exports.default = {
  KEY: KEY,
  VALUE: VALUE
};